// @flow
import * as React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router';
import CampaignSelect from './CampaignSelect';
import { Marker, Target, MagnifyingGlass, Mail } from './Icons';
import HelpWrapper from './HelpWrapper';

type Params = {
  context: string,
  organisationId: number,
  campaignId: string | number
};

type Props = {
  pdfUrl?: string,
  videoUrl?: string,
  params: Params,
  currentStep: number,
  campaignStatus: number,
  canExport?: boolean,
  showSelect?: boolean,
  campaignIsLocked: boolean
};

class CampaignHeader extends React.Component<Props> {
  getColor = (step: number): ?string => {
    const {
      campaignStatus,
      canExport,
      currentStep,
      campaignIsLocked
    } = this.props;
    const completedColor = '#3f8e42';
    const incompleteButAccessibleColor = '#db1929';

    // completed steps
    if (campaignStatus > step || campaignIsLocked) {
      return completedColor;
    }

    if (campaignStatus === step && step !== 3) {
      return canExport ? completedColor : incompleteButAccessibleColor;
    }

    if (step === 3 && campaignStatus > step && !canExport) {
      return incompleteButAccessibleColor;
    }
    if (step === 3 && currentStep === 2 && canExport) {
      return incompleteButAccessibleColor;
    }
    if (step === 3 && campaignStatus >= 3) {
      return incompleteButAccessibleColor;
    }

    // if(step === 3 & currentStep >= 3) {
    //   return incompleteButAccessibleColor;
    // }

    if (step === 3 && currentStep === 3 && campaignStatus === 3) {
      return incompleteButAccessibleColor;
    }

    // return incompleteButAccessibleColor;

    // return inaccessible color (grey)
  };

  getClassNames = (step: number): string => {
    const {
      campaignStatus,
      currentStep,
      canExport,
      campaignIsLocked
    } = this.props;
    let classNames = '';

    if (campaignIsLocked) {
      return 'accessible completed';
    }

    if (campaignStatus >= step) {
      classNames = 'accessible ';
    }

    if (campaignStatus > step) {
      classNames = 'completed ';
    }

    if (step === 3 && currentStep === 2 && canExport) {
      classNames = 'accessible ';
    }

    if (step === 3 && currentStep === 3) {
      classNames = 'accessible ';
    }

    if (currentStep === step) {
      classNames += 'active ';
      if (currentStep === 2 && canExport) {
        classNames += 'completed ';
      }
    }
    return classNames;
  };

  headerLink = (e: Event, desiredStep: number) => {
    const {
      params: { campaignId = 'new' },
      campaignStatus,
      currentStep,
      campaignIsLocked
    } = this.props;
    if (campaignIsLocked) {
      return;
    }
    if (currentStep === 1 && campaignId === 'new') {
      e.preventDefault();
      return;
    }
    const oneStepForward = campaignStatus + 1;
    if (desiredStep > oneStepForward) {
      console.log('No access to step ' + desiredStep + ' yet.');
      e.preventDefault();
      return;
    }
    // need to Save before you can access export page
    if (desiredStep === 3 || desiredStep === 4) {
      if (desiredStep !== currentStep && desiredStep > currentStep) {
        const canExport = localStorage.getItem('canExport');
        if (!canExport) {
          alert('You need to save before accessing this step.');
          e.preventDefault();
          return;
        }
      }
    }
  };

  render() {
    const {
      params: { context, organisationId, campaignId = 'new' },
      showSelect,
      pdfUrl,
      videoUrl,
      campaignIsLocked
    } = this.props;

    const isNew = campaignId === 'new';
    const campaignBaseUrl = `/${context}/${organisationId}/campaigns`;
    const newUrl = `${campaignBaseUrl}/new`;
    const mapUrl = `${campaignBaseUrl}/${campaignId}/map`;
    const reviewUrl = `${campaignBaseUrl}/${campaignId}/review`;
    const bookUrl = `${campaignBaseUrl}/${campaignId}/book`;
    var editLabel = '1. Edit';

    if (isNew) {
      editLabel = '1. Create';
    } else if (campaignIsLocked) {
      editLabel = '1. View';
    }

    const createEditUrl = isNew ? newUrl : `${campaignBaseUrl}/${campaignId}`;

    return (
      <Row className="campaign-header-section">
        <Col xs={3}>
          {showSelect && (
            <CampaignSelect
              organisationId={parseInt(organisationId, 10)}
              campaignId={parseInt(campaignId, 10)}
              context={context}
            />
          )}
        </Col>
        <Col xs={9}>
          {!this.props.isGlobal && (
            <ul className="list-inline">
              <li>
                <Link to={createEditUrl} onClick={e => this.headerLink(e, 1)}>
                  <div className="icon">
                    <MagnifyingGlass height="24px" color={this.getColor(1)} />
                  </div>
                  <div className={this.getClassNames(1)}>{editLabel}</div>
                </Link>
              </li>
              <li>
                <Link to={mapUrl} onClick={e => this.headerLink(e, 2)}>
                  <div className="icon">
                    <Marker height="32px" color={this.getColor(2)} />
                  </div>
                  <div className={this.getClassNames(2)}>2. Map</div>
                </Link>
              </li>
              <li>
                <a href={reviewUrl} onClick={e => this.headerLink(e, 3)}>
                  <div className="icon">
                    <Target height="30px" color={this.getColor(3)} />
                  </div>
                  <div className={this.getClassNames(3)}>3. Review</div>
                </a>
              </li>
              <li>
                <Link to={bookUrl} onClick={e => this.headerLink(e, 4)}>
                  <div className="icon">
                    <Mail height="30px" color={this.getColor(4)} />
                  </div>
                  <div className={this.getClassNames(4)}>4. Book</div>
                </Link>
              </li>
            </ul>
          )}
          <HelpWrapper
            pdfUrl={pdfUrl}
            videoUrl={videoUrl}
            extraClass={!this.props.isGlobal ? 'inside-campaign-header' : ''}
          />
        </Col>
      </Row>
    );
  }
}

export default CampaignHeader;



// WEBPACK FOOTER //
// ./src/components/CampaignHeader.js